import "./style/index.scss";
import { Button, Col, Divider, Flex, Form, Row, Select, Image, Switch } from "antd";
import { setModalPermissaoUsuario } from "../../../../redux/slices/account/accountSlice";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { useEffect } from "react";
import { atualizarUsuarioEmpresa } from "../../../../services/accountService";
import { AtualizarUsuarioEmpresaModel } from "../../../../models/account/chamadas/atualizarUsuarioEmpresaModel";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

const PermissoesUsuarioModal = () => {
  //estados globais
  const accountState = useAppSelector((state) => state.account);
  const empresaState = useAppSelector((state) => state.empresa);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<AtualizarUsuarioEmpresaModel>();

  useEffect(() => {
    form.setFieldsValue({
      empresas: accountState.usuario.empresas ? accountState.usuario.empresas : [],
    });
  }, [accountState.usuario]);

  const submit = (values: AtualizarUsuarioEmpresaModel) => {
    dispatch(atualizarUsuarioEmpresa({ value: { ...values, idUsuario: accountState.usuario.id }, busca: accountState.busca }));
  };

  const voltar = () => {
    dispatch(setModalPermissaoUsuario(false));
  };

  return (
    <Flex vertical>
      <Form form={form} layout="vertical" onFinish={submit}>
        <Row gutter={12} align="bottom" className="row_only_label ">
          <Col span={17}>
            <Form.Item label="Empresa"></Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item label="Acesso total"></Form.Item>
          </Col>
        </Row>
        <Row gutter={12} align="bottom">
          <Flex gap={8} style={{ width: "100%" }} vertical>
            <Form.List name="empresas">
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Flex align="center" style={{ width: "100%" }} key={key}>
                      <Col span={17}>
                        <Form.Item label="EMPRESA" name={[name, "idEmpresa"]} noStyle>
                          <Select
                            showSearch
                            optionFilterProp="labelSearch"
                            loading={empresaState.loading}
                            style={{ width: "100%" }}
                            options={empresaState.list.map((a: any) => ({
                              value: a.id,
                              label: (
                                <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                                  <div style={{ lineHeight: "0px" }}>
                                    {a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}
                                  </div>
                                  <div>{a.apelido}</div>
                                </Flex>
                              ),
                              labelSearch: a.apelido,
                            }))}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col span={7}>
                        <Form.Item label="ACESSO TOTAL" name={[name, "permissao"]} noStyle>
                          <Switch size="small" />
                        </Form.Item>
                      </Col>
                    </Flex>
                  ))}
                </>
              )}
            </Form.List>
          </Flex>
        </Row>
        <Divider />
        <Flex align="center" justify="flex-end" gap={10}>
          <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
            FECHAR
          </Button>
          <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
            SALVAR
          </Button>
        </Flex>
      </Form>
    </Flex>
  );
};

export default PermissoesUsuarioModal;
